import{StateNode as t}from"./StateNode.js";function o(o,e,n){return void 0===n&&(n=o.context),new t(o,e,n)}export{o as Machine};
//# sourceMappingURL=Machine.js.map
